import { createAction, createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ReduxState } from 'reducers/root.reducer'
import { State } from 'features/auth/Auth.type'

export const initialState: State = {
  cognitoSub: null,
  envy: {
    active: null,
  },
  user: {
    active: null,
  },
}

const name = 'global/auth'
export const invalidateCache = createAction(`${name}/invalidateCache`)

const slice = createSlice({
  name,
  initialState,
  reducers: {
    setCognitoSub(state, action: PayloadAction<string | null>) {
      state.cognitoSub = action.payload
    },
    setActiveEnvy(state, action: PayloadAction<string | null>) {
      state.envy.active = action.payload
    },
    setActiveUser(state, action: PayloadAction<string | null>) {
      state.user.active = action.payload
    },
  },
  extraReducers(builder) {
    builder.addCase(invalidateCache, (state) => {
      state.cognitoSub = initialState.cognitoSub
      state.envy = initialState.envy
      state.user = initialState.user
    })
  },
})

export const { setCognitoSub, setActiveEnvy, setActiveUser } = slice.actions

export default slice.reducer

export const selectAuth = (state: ReduxState) => state.auth
export const selectCognitoSub = createSelector(selectAuth, (auth) => auth.cognitoSub)
export const selectEnvy = createSelector(selectAuth, (auth) => auth.envy)
export const selectActiveEnvy = createSelector(selectEnvy, (envy) => envy.active)
export const selectActiveUser = createSelector(selectAuth, (auth) => auth.user.active)
